import { func, shape, string } from "prop-types";
import { Link } from "react-router-dom";

import LazyLoadImage from "web/Layout/Common/LazyLoadImage";

import classes from "./image.scss";

const ProductCardImage = ({ className, name, image, to, onClick }) => {
  return (
    <Link to={to} className={className} title={name} onClick={onClick}>
      <LazyLoadImage
        className={classes.image}
        src={image}
        alt={name}
        width={400}
        height={264}
        isProduct
      />
    </Link>
  );
};

ProductCardImage.propTypes = {
  className: string.isRequired,
  to: shape({}).isRequired,
  name: string.isRequired,
  image: string.isRequired,
  onClick: func,
};

ProductCardImage.defaultProps = {
  onClick: () => {},
};

export default ProductCardImage;
